import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, InputGroup, Form, Button, Card } from 'react-bootstrap'

import { FreeMode, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import styles from './../blocks.module.sass'

function SlideButtons() {
  const swiper = useSwiper()

  return (
    <div className='d-none d-lg-flex swiper-mynavbtns'>
      <div className='swiper-button-prev swiper-button-spstyle' onClick={() => swiper.slidePrev()} />
      <div className='swiper-button-next swiper-button-spstyle' onClick={() => swiper.slideNext()} />
    </div>
  )
}

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, catalogmenu, search, changeSearch, changeTopSearch } = this.props

    return (
      <>
        <div className={styles.catalogng_tab}>
          <Container>
            <div className='d-flex align-items-center justify-content-between'>
              <InputGroup className={styles.catalogng_tab_search}>
                <Form.Control
                  placeholder="Поиск"
                  aria-label="Поиск"
                  aria-describedby="basic-catalogng_tab-search"
                  className={styles.catalogng_tab_search_input}
                  value={search}
                  onChange={(e) => changeSearch( e.target.value )}
                />
                <Button onClick={() => changeTopSearch()} variant="light" id="button-catalogng_tab-search" className={styles.catalogng_tab_search_button}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 9L13 13M5.66667 10.3333C3.08934 10.3333 1 8.244 1 5.66667C1 3.08934 3.08934 1 5.66667 1C8.244 1 10.3333 3.08934 10.3333 5.66667C10.3333 8.244 8.244 10.3333 5.66667 10.3333Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Button>
              </InputGroup>
              <Button href={page_data.new_link} className={styles.catalogng_tab_btn} variant="light">Новые поступления</Button>
              {catalogmenu.map((elm, k) => {
                  return (
                    <Button key={k} href={elm.url} className={styles.catalogng_tab_btn} variant={k == 0 ? `dark` : `light`}>{elm.name}</Button>
                  )
              })}
              <Button href={page_data.karti_link} className={styles.catalogng_tab_btn} variant="light">Подарочные карты</Button>
              <Button href={page_data.poshiv_link} className={styles.catalogng_tab_btn} variant="light">Индивидуальный пошив</Button>
            </div>
          </Container>
        </div>
        {ajax_data != null &&
          <div className={styles.catalogng}>
            <Container>
              <div className='w-100 d-flex justify-content-between align-items-end'>
                <div className={styles.catalogng_title}>КАТАЛОГ</div>
                <a href={page_data.man_link} className={styles.catalogng_all}>Смотреть все →</a>
              </div>
              <div className={styles.catalogng_slyder}>
                {'catalog_ng' in ajax_data &&
                  <Swiper
                    modules={[FreeMode, Pagination]}
                    pagination={{ type: `progressbar` }}
                    spaceBetween={6}
                    slidesPerView={`auto`}
                    freeMode={true}
                    speed={300}
                  >
                    {ajax_data.catalog_ng.map(( elm, key ) => {
                      return (
                        <SwiperSlide key={key} className={styles.catalogng_slyder_slyde_width}>
                          <Card className={styles.catalogng_slyder_slyde}>
                            <Card.Img src={elm.photo} width={259} height={376} alt="Аксессуары" />
                            <Card.ImgOverlay className={styles.catalogng_slyder_slyde_content}>
                              <a href={elm.link} className={styles.catalogng_slyder_slyde_content_link + ` stretched-link`}>
                                <div>{elm.name}</div>
                                <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L1 12" stroke="white" strokeLinecap="round"/>
                                </svg>
                              </a>
                            </Card.ImgOverlay>
                          </Card>
                        </SwiperSlide>
                      )
                    })}
                    <SwiperSlide className={styles.catalogng_slyder_slyde_width}></SwiperSlide>
                    <SlideButtons />
                  </Swiper>
                }
              </div>
            </Container>
          </div>
        }
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  catalogmenu: PropTypes.array,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func
}